<template>
  <div class="box">
    <table class="table" id="my-table">
      <thead>
        <tr>
          <th>Activity</th>
          <th class="is-md">Description</th>
          <th class="is-sm">Create by</th>
          <th class="is-md">Company</th>
          <th>Point</th>
          <th>Remark</th>
          <th class="is-sm">Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(b, idx) in activity" :key="idx">
          <td>{{ b.activity }}</td>
          <td>{{ b.description }}</td>
          <td>{{ b.creator }}</td>
          <td>{{ b.companyName }}</td>
          <td>{{ b.point }}</td>
          <td>{{ b.remark }}</td>
          <td>{{ b.activityDate }}</td>
        </tr>
      </tbody>
    </table>
    <infinite-loading spinner="spiral" @infinite="infiniteScroll">
    </infinite-loading>
  </div>
</template>

<script>
import { GET_ACTIVITY } from "./../../graphql/employer/company";
import { apolloClient } from "./../../services/apollo-client";
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    InfiniteLoading,
  },
  data: () => ({
    modalClick: false,
    activity: [],
    page: 1,
    perPage: 5,
  }),
  created() {
    this.queryActivity();
  },
  methods: {
    async infiniteScroll($state) {
      setTimeout(async () => {
        this.page++;
        const res = await apolloClient.query({
          query: GET_ACTIVITY,
          variables: {
            UserId: this.$route.params.UserId,
            page: this.page,
            perPage: this.perPage,
          },
        });
        let getData = res.data.get_Activity.info;
        if (getData.length > 1) {
          this.activity.push(...getData);
          $state.loaded();
        } else {
          $state.complete();
        }
      }, 500);
    },

    async queryActivity() {
      const res = await apolloClient.query({
        query: GET_ACTIVITY,
        variables: {
          UserId: this.$route.params.UserId,
          page: 1,
          perPage: 100000,
        },
      });
      this.activity = res.data.get_Activity.info;
    },
  },
};
</script>

<style lang="scss" scoped></style>
